import styled, { css } from 'styled-components'

import FormLabel from '../../FormLabel'
import Icon from '../../../Icon'

export const Container = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  flex-flow: column;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled(FormLabel)<{ $isBigLabel: boolean }>`
  ${({ $isBigLabel }) =>
    $isBigLabel
      ? css`
          ${({ theme }) => theme.textStyles.H5}
        `
      : css`
          ${({ theme }) => theme.textStyles.textLargeStrong}
        `}
  color: ${({ theme }) => theme.colors.nightRider};
  margin-bottom: ${({ $isBigLabel }) => ($isBigLabel ? '3.2rem' : '1rem')};
  text-align: ${({ $isBigLabel }) => ($isBigLabel ? 'center' : 'left')};
`

export const SelectContainer = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.colors.pureWhite};
  border-radius: 0.8rem;
`

export const Select = styled.select<{ $error?: boolean }>`
  display: block;
  width: 100%;
  padding: 1.2rem 2.4rem 1.2rem 1.2rem;
  ${(props) => props.theme.textStyles.textLarge};
  color: ${(props) => props.theme.colors.nightRider};
  border: 1px solid ${(props) => props.theme.colors.gainsboro};
  border-radius: 0.8rem;
  box-shadow: none;
  background-color: transparent;
  outline: none;
  appearance: none;
  cursor: pointer;
  position: relative;
  z-index: 2;

  ${(props) =>
    props.$error &&
    css`
      color: ${(props) => props.theme.colors.red};
      border-color: ${(props) => props.theme.colors.red};
    `}

  ${(props) =>
    !props.value &&
    css`
      color: #808080;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      user-select: none;
    `};

  & option[value=''][disabled] {
    display: none;
  }
`

export const SelectArrow = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  color: ${(props) => props.theme.colors.pureBlack};
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 0.5rem;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.textMedium}
  color: grey;
  margin-top: 0.5rem;
`
